import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AlertModal2 from "../../utility/component/modals/alertWithLottie";
import GeniustextInput from "../../utility/component/mastertext";

import ModalHeaderStyle from "../../utility/component/styles/modalHeader";
import CallAPI from "../../utility/functions/getData";
import {
  ModifyButton,
  SaveButton,
  UndoButton,
} from "../../utility/component/buttons";
import {
  setAlertWithTitle,
  setSessionExpired,
  setSpinnerLoading,
} from "../../utility/Redux/modal";
import { useFocus } from "../../utility/hooks/hooks";
import { useNavigate } from "react-router-dom";
import { selectToken } from "../../utility/Redux/security";
import { toProperCase } from "../../utility/component/format";
import CustomerMasterHelp from "../../help/customermasterHelp";
import { selectPrefix, selectWidth } from "../../utility/Redux/profile";
import { CallAPIPromise, emailRegex } from "../../billing/common";
import Lottie from "lottie-react";
import spinner from "../../../src/utility/json/Spinner.json";
import SendOtp from "../../utility/functions/sendOtp";
import { getRandomNumber } from "../../auth/login/func";
import OtpAlertModal from "../../utility/component/modals/otpAlert";
import EmailChangeModal from "./emailChangeModal";

import MobileChangeModal from "./mobileChangeModal";
import { getCountryInfo, GetCoutryList } from "../../utility/functions/common";
export const mobilPrefixOptions = [
  { name: "+91", value: "+91" },
  { name: "+1", value: "+1" },
  { name: "+44", value: "+44" },
  { name: "+971", value: "+971" },
  { name: "+61", value: "+61" },
  { name: "+81", value: "+81" },
  { name: "+49", value: "+49" },
  { name: "+33", value: "+33" },
  { name: "+39", value: "+39" },
  { name: "+34", value: "+34" },
  { name: "+86", value: "+86" },
  { name: "+7", value: "+7" },
  { name: "+55", value: "+55" },
  { name: "+92", value: "+92" },
  { name: "+880", value: "+880" },
  { name: "+234", value: "+234" },
  { name: "+62", value: "+62" },
  { name: "+82", value: "+82" },
  { name: "+966", value: "+966" },
  { name: "+965", value: "+965" },
  { name: "+20", value: "+20" },
  { name: "+27", value: "+27" },
  { name: "+212", value: "+212" },
  { name: "+90", value: "+90" },
  { name: "+52", value: "+52" },
];

const CustomerMaster = ({ onClose, afterCreate }) => {
  const [id, setId] = useState("");
  const [randome, setRandome] = useState("");
  const [mobilePrefix, setMobilePrefix] = useState("+91");

  const [otpStatus, setOtpStatus] = useState(false);
  const [mobile, setMobile] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [emailVerfied, setEmailVerified] = useState(false);
  const [mobileVerfied, setMobileVerfied] = useState(false);
  const [address, setAddress] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [alert, setAlert] = useState("");
  const [type, setType] = useState("Customer");
  const [status, setStatus] = useState("Active");
  const [prevBal, setPrevBal] = useState("");
  const [balType, setBalType] = useState("Dr.");
  const [rateType, setRateType] = useState("sale_price");
  const [customerList, setCustomerList] = useState([]);
  const [emailStatus, setEmailStatus] = useState(false);
  const [mobileStatus, setMobileStatus] = useState(false);
  const [companyData, setCompanyData] = useState({
    COMPANY_NAME: "",
    COMPANY_ADDRESS: "",
    COMPANY_MOBILE: "",
    TAX_NUMBER: "",
    PAN_NO: "",
    TAN: "",
  });
  const [discount, setDiscount] = useState("");
  const [loyalty, setLoyalty] = useState("");
  const [minLoyalty, setMinLoyalty] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [webcamStatus, setWebcamStatus] = useState("");
  const [capturedImage, setCapturedImage] = useState("");
  const webcamRef = useRef(null);
  const [selectedState, setSelectedState] = useState("Punjab");
  const [city, setCity] = useState("Jalandhar");
  const [countryList, setCountryList] = useState([]);
  const [statesList, setStateslist] = useState([]);
  const [citysList, setCityslist] = useState([]);

  const handleStateChange = (e) => {
    setSelectedState(e.target.value);
    const states = e.target.list ? e.target.list : statesList;
    const stateDetails = states.filter((c) => c.name === e.target.value);
    if (stateDetails[0]) {
      getCountryInfo(stateDetails[0].geonameId).then((res) => {
        setCityslist(res?.data?.geonames ? res?.data?.geonames : []);
      });
    }
  };

  const [selectedCountry, setSelectedCountry] = useState("India");
  const handleCountryChange = async (e) => {
    return new Promise((resolve, reject) => {
      setSelectedCountry(e.target.value);
      const countryDetails = countryList.filter(
        (c) => c.countryName === e.target.value
      );
      if (countryDetails[0]) {
        getCountryInfo(countryDetails[0].geonameId).then((res) => {
          setStateslist(res?.data?.geonames ? res?.data?.geonames : []);
          resolve(res?.data?.geonames ? res?.data?.geonames : []);
        });
      }
    });
  };

 useEffect(()=>{
  const countryDetails = countryList.filter(
    (c) => c.countryName === 'India'
  );
  if (countryDetails[0]) {
    getCountryInfo(countryDetails[0].geonameId).then((res) => {
      setStateslist(res?.data?.geonames ? res?.data?.geonames : []);

      const states =res?.data?.geonames ? res?.data?.geonames : []
      const stateDetails = states.filter((c) => c.name === "Punjab");
      if (stateDetails[0]) {
        getCountryInfo(stateDetails[0].geonameId).then((res) => {
          setCityslist(res?.data?.geonames ? res?.data?.geonames : []);
        });
      }
    });
  }
 },[countryList])
  const [customerMasterHelpStatus, setCustomerMasterHelpStatus] =
    useState(false);

  const [mobileRef, setMobileError] = useFocus();
  const [customerNameRef, setCustomerNameError] = useFocus();
  const [emailRef, setEmailError] = useFocus();
  const [addressRef, setAddressError] = useFocus();
  const [pinCodeRef, setPinCodeError] = useFocus();
  const [typeRef, setTypeError] = useFocus();
  const [prevBalRef, setPrevBalError] = useFocus();
  const [discountRef, setDiscountError] = useFocus();
  const [loyaltyRef, setLoayaltyError] = useFocus();
  const [firebaseImage, setFirebaseUrl] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const prefix = useSelector(selectPrefix);
  const token = useSelector(selectToken);
  const [Path, setpath] = useState("");
  const saveCustomerMaster = () => {
    if (customerName && mobile) {
      if (id) {
        saveCustomer(id);
      } else {
        CallAPIPromise(
          "/api/customerMasterUtils/listCustomerMaster",
          {
            table_prefix_master: prefix,
            CUSTOMER_MOBILE: mobile,
            CUSTOMER_NAME: "",
          },
          token
        ).then((res) => {
          if (res.data.response[0]) {
            saveCustomer(res.data.response[0].CUSTOMER_CODE);
          } else {
            saveCustomer("");
          }
        });
      }
    } else {
      if (!companyData.TAX_NUMBER) {
        setMobileError();
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Please Enter GST Number.",
          })
        );
      }

      if (!customerName) {
        setCustomerNameError();
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Please Enter Customer Name.",
          })
        );
      }
      if (!mobile) {
        setMobileError();
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Please Enter Mobile.",
          })
        );
      }
    }
  };
  const saveCustomer = (code) => {
    const data = {
      table_prefix_master: prefix.replace(/_.+_/, "_"),
      CUSTOMER_CODE: code,
      CUSTOMER_NAME: customerName,
      CUSTOMER_ADDRESS: address,
      EMAIL_VERIFIED: emailVerfied ? "Yes" : "No",
      MOBILE_VERIFIED: mobileVerfied ? "Yes" : "No",
      CUSTOMER_MOBILE: mobile,
      CUSTOMER_EMAIL: email,
      CUSTOMER_TYPE: type ? type : "Customer",
      CITY: city,
      COUNTRY: selectedCountry,
      PIN_CODE: pinCode,
      DISQ_RATE: discount ? Number(discount) : 0,
      LOYALTY_POINTS: loyalty ? loyalty : "0",
      CUSTOMER_STATUS: status ? status : "Active",
      PRV_BAL: prevBal ? prevBal : "0",
      BAL_TYPE: balType ? balType : "Dr.",
      RATE_TYPE: rateType ? rateType : "sale_price",
      COMPANY_NAME: companyData.COMPANY_NAME,
      COMPANY_ADDRESS: companyData.COMPANY_ADDRESS,
      COMPANY_MOBILE: companyData.COMPANY_MOBILE,
      TAX_NUMBER: companyData.TAX_NUMBER,
      PAN_NO: companyData.PAN_NO,
      TAN: companyData.TAN,
      LOYALTY_POINT_AMT:minLoyalty
    };
    dispatch(setSpinnerLoading("Saving"));
    CallAPI(
      "/api/customerMaster/saveCustomerMaster",
      data,
      token,
      (e) => {
        if (!e.data.error) {
          dispatch(
            setAlertWithTitle({
              title: "Alert",
              msg: id ? "Data Updated." : "Data Saved Successfully.",
            })
          );
          clearState();
          getData();
          if (afterCreate) {
            afterCreate();
          }
        } else {
          dispatch(
            setAlertWithTitle({
              title: "Alert",
              msg: "Something Went Wrong.",
            })
          );
        }
      },
      dispatch,
      () => {
        dispatch(setSpinnerLoading(false));
      }
    );
  };
  const clearState = () => {
    setMobile("");
    setCustomerName("");
    setId("");
    setEmail("");
    setAddress("");
    setSelectedCountry("India");
    setSelectedState("Punjab");
    setCity("Jalandhar");
    setPinCode("");
    setType("");
    setStatus("");
    setPrevBal("");
    setBalType("Dr.");
    setRateType("sale_price");
    setDiscount("");
    setLoyalty("");
    setSelectedFile(null);
    setCapturedImage(null);
    setEmailVerified(false);
    setMobileVerfied(false);
    setFirebaseUrl("");
    setCompanyData({
      COMPANY_NAME: "",
      COMPANY_ADDRESS: "",
      COMPANY_MOBILE: "",
      TAX_NUMBER: "",
      PAN_NO: "",
      TAN: "",
    });
  };

  const formRef = useRef(null);
  useEffect(() => {
    GetCoutryList().then((res) => {
      setCountryList(res.data.geonames);
    });
  }, []);
  useEffect(() => {
    const inputFields = formRef.current.querySelectorAll(
      "input, select,textarea"
    );

    inputFields.forEach((field, index) => {
      field.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault(); // Prevent form submission
          const nextIndex = (index + 1) % inputFields.length;
          if (index === 20) {
            inputFields[0].focus();
          } else {
            if (index === 7) {
              inputFields[11].focus();
            } else {
              inputFields[nextIndex].focus();
            }
          }
        }
      });
    });

    return () => {
      inputFields.forEach((field) => {
        field.removeEventListener("keydown", () => {});
      });
    };
  }, []);

  const getData = async () => {
    dispatch(setSpinnerLoading("Loading"));
    const data = {
      table_prefix_master: prefix.replace(/_.+_/, "_"),
      CUSTOMER_MOBILE: "",
      CUSTOMER_NAME: "",
    };
    CallAPIPromise("/api/customerMasterUtils/listCustomerMaster", data, token)
      .then((p) => {
        setCustomerList(p.data.response);
      })
      .catch((error) => {
        if (error.response.data.name === "TokenExpiredError") {
          dispatch(setSessionExpired(true));
        }
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  useEffect(() => {
    if (status) {
      getData();
    }
  }, [status]);

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    function handleKeyPress(event) {
      // Check if Ctrl or Alt key is pressed along with 'S'
      if ((event.ctrlKey || event.altKey) && event.key === "s") {
        // Call your function here
        saveCustomerMaster();
      }
    }

    // Add event listener when component mounts
    window.addEventListener("keydown", handleKeyPress);

    // Remove event listener when component unmounts
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [
    customerName,
    prefix,
    email,
    address,
    mobile,
    selectedCountry,
    city,
    pinCode,
    type,
    status,
    prevBal,
    discount,
    balType,
    loyalty,
    companyData.COMPANY_NAME,
    companyData.COMPANY_ADDRESS,
    companyData.COMPANY_MOBILE,
    companyData.TAX_NUMBER,
    companyData.PAN_NO,
    companyData.TAN,
  ]);
  const windowWidth = useSelector(selectWidth);

  const VerfiyEmailSentAPI = (newEmail) => {
    return new Promise((resolve, reject) => {
      CallAPIPromise(
        "/api/customerMaster/resendVerifyEmail",
        {
          table_prefix: prefix,
          customerName: customerName,
          code: id,
          to: newEmail ? newEmail : email,
        },
        token
      )
        .then((t) => resolve(t))
        .catch((e) => {
          reject(e);
        });
    });
  };
  const VerfiyMobileAPI = (newMobile) => {
    return new Promise((resolve, reject) => {
      CallAPIPromise(
        "/api/customerMaster/updateVerifyCustomerMobile",
        {
          table_prefix: prefix,
          CUSTOMER_CODE: id,
          MOBILE_VERIFIED: "Yes",
          CUSTOMER_MOBILE: newMobile ? newMobile : mobile,
        },
        token
      )
        .then((t) => resolve(t))
        .catch((e) => {
          reject(e);
        });
    });
  };
  const OtpSentAPI = (newMobile) => {
    return new Promise((resolve, reject) => {
      const randomeNumber = getRandomNumber();
      setRandome(randomeNumber);
      SendOtp(
        newMobile ? newMobile : mobile,
        prefix.replace(/_.+_/, "_"),
        randomeNumber,
        email,
        dispatch,
        token,
        "Customer Verify",
        "otp"
      )
        .then((e) => {
          resolve(e);
        })
        .catch((e) => reject(e));
    });
  };
  return (
    <div
      ref={formRef}
      className="w-full  flex justify-center bg-[#f5f5f7] h-full  px-3"
    >
      <div className="text-sm   rounded-sm   flex flex-col   h-full py-4 ">
        <div>
          <ModalHeaderStyle
            header={"Customer Master"}
            onClose={() => {
              if (onClose) {
                onClose();
              } else {
                navigate("/masters");
              }
            }}
          />
        </div>
        <div
          style={{
            height: `90%`,
          }}
          className="   rounded-b-sm  bg-[#fdfffe] flex flex-col   p-1 "
        >
          <div className="h-[16px] text-red-500 pl-6">{alert}</div>
          <div className=" h-full overflow-y-auto overflow-x-hidden   text-black   flex-col l:flex l:flex-row px-4 pb-4">
            <div className="h-fit ">
              <div className="border max-w-[400px] border-[#b5b3b3] min-w-[280px] bg-white rounded-sm p-4 mt-2 grid grid-cols-1 ">
                <GeniustextInput
                  search={() => {
                    setCustomerMasterHelpStatus(true);
                  }}
                  refrance={mobileRef}
                  title={"Customer"}
                  type={"countryMobile"}
                  readOnly={id ? true : false}
                  grid={true}
                  titleButton={
                    <div className="ml-1 text-red-500 text-[14px]">
                      {mobileVerfied && id && mobile.length > 9 ? (
                        <button
                          onClick={() => {
                            setMobileStatus(true);
                          }}
                        >
                          {" "}
                          Change Mobile
                        </button>
                      ) : null}
                    </div>
                  }
                  inputButton={
                    !mobileVerfied && id && mobile.length > 9 ? (
                      <button
                        onClick={() => {
                          if (loading !== "mobile") {
                            setLoading("mobile");
                            OtpSentAPI()
                              .then((e) => {
                                setOtpStatus(true);
                                setMobileVerfied(true);
                              })
                              .catch((e) => console.log(e))
                              .finally(() => {
                                setLoading(false);
                              });
                          }
                        }}
                        className=" px-3  h-full text-sm bg-red-500 text-white flex items-center"
                      >
                        {loading === "mobile" ? (
                          <div className="w-6 h-6">
                            <Lottie
                              animationData={spinner}
                              loop={true}
                              style={{ fontSize: 15 }}
                              color="white"
                            />
                          </div>
                        ) : (
                          "Verify"
                        )}
                      </button>
                    ) : mobileVerfied && id && mobile.length > 9 ? (
                      <button className=" px-2  h-full text-sm bg-[#41ae39] text-white   flex items-center">
                        <i className="bi bi-patch-check text-[20px]"></i>
                      </button>
                    ) : null
                  }
                  value={mobile}
                  onChange={(t) => {
                    const value = t;
                    if (value.length < 16) {
                      const isDuplicate = customerList.filter(
                        (c) => c.CUSTOMER_MOBILE === value
                      );
                      if (!isDuplicate[0]) {
                        setMobile(value);
                      } else {
                        dispatch(
                          setAlertWithTitle({
                            title: "Alert",
                            msg: "Mobile already exist",
                          })
                        );
                      }
                    } else {
                      dispatch(
                        setAlertWithTitle({
                          title: "Alert",
                          msg: "Please enter a valid  mobile number.",
                        })
                      );
                    }
                  }}
                />
                <GeniustextInput
                  title={"Customer Name"}
                  type={"text"}
                  refrance={customerNameRef}
                  value={customerName}
                  width="auto"
                  grid={true}
                  onChange={(e) => setCustomerName(e.target.value)}
                />
                <GeniustextInput
                  title={"Email"}
                  type={"text"}
                  error={"email"}
                  grid={true}
                  titleButton={
                    <div className="ml-1 text-red-500 text-[14px]">
                      {emailVerfied && id && emailRegex.test(email) ? (
                        <button
                          onClick={() => {
                            setEmailStatus(true);
                          }}
                        >
                          {" "}
                          Change Email
                        </button>
                      ) : null}
                    </div>
                  }
                  readOnly={id ? true : false}
                  refrance={emailRef}
                  value={email}
                  inputButton={
                    !emailVerfied && id && emailRegex.test(email) ? (
                      <button
                        onClick={() => {
                          if (loading !== "email") {
                            setLoading("email");
                            VerfiyEmailSentAPI()
                              .then((e) => {
                                setEmailVerified(true);
                                setAlert("Verification Email Sent");
                                setTimeout(() => {
                                  setAlert("");
                                }, 6000);
                              })
                              .catch((e) => console.log(e))
                              .finally(() => {
                                setLoading(false);
                              });
                          }
                        }}
                        className=" px-3  h-full text-sm bg-red-500 text-white   flex items-center"
                      >
                        {loading === "email" ? (
                          <div className="w-6 h-6">
                            <Lottie
                              animationData={spinner}
                              loop={true}
                              style={{ fontSize: 15 }}
                              color="white"
                            />
                          </div>
                        ) : (
                          "Verify"
                        )}
                      </button>
                    ) : emailVerfied && id && emailRegex.test(email) ? (
                      <button className=" px-2  h-full text-sm bg-[#41ae39] text-white   flex items-center">
                        <i className="bi bi-patch-check text-[20px]"></i>
                      </button>
                    ) : null
                  }
                  onChange={(t) => {
                    const isDuplicate = customerList.filter(
                      (c) =>
                        c.CUSTOMER_EMAIL === t.target.value && c.CUSTOMER_EMAIL
                    );
                    if (!isDuplicate[0]) {
                      setEmail(t.target.value);
                    } else {
                      dispatch(
                        setAlertWithTitle({
                          title: "Alert",
                          msg: "Email already exist",
                        })
                      );
                    }
                  }}
                />
                <GeniustextInput
                  title={"Address"}
                  type={"text"}
                  grid={true}
                  width="auto"
                  value={address}
                  refrance={addressRef}
                  onChange={(e) => setAddress(toProperCase(e.target.value))}
                />
                <div className="grid grid-cols-1 t:grid-cols-2 gap-2 ">
                  <GeniustextInput
                    title={"Country"}
                    width="auto"
                    grid={true}
                    option={countryList.map((c) => {
                      return {
                        label: c.countryName,
                        value: c.countryName,
                        name: c.countryName,
                      };
                    })}
                    value={selectedCountry}
                    onChange={handleCountryChange}
                  />
                  <GeniustextInput
                    title={"State"}
                    grid={true}
                    option={statesList.map((s) => {
                      return {
                        label: s.name,
                        value: s.name,
                        name: s.name,
                      };
                    })}
                    value={selectedState}
                    onChange={handleStateChange}
                  />
                </div>
                <div className="grid grid-cols-1 t:grid-cols-2 gap-2">
                  <GeniustextInput
                    title={"City"}
                    grid={true}
                    width="auto"
                    option={citysList.map((s) => {
                      return {
                        label: s.name,
                        value: s.name,
                        name: s.name,
                      };
                    })}
                    value={city}
                    onChange={(e) => {
                      setCity(e.target.value);
                    }}
                  />
                  <div className="">
                    <GeniustextInput
                      title={"Pin Code"}
                      type={"text"}
                      refrance={pinCodeRef}
                      value={pinCode}
                      grid={true}
                      width="auto"
                      onChange={(e) => setPinCode(e.target.value)}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <GeniustextInput
                    title={"Type"}
                    option={[
                      {
                        name: "Customer",
                        value: "Customer",
                      },
                      {
                        name: "NC Guest",
                        value: "NC Guest",
                      },
                    ]}
                    width="auto"
                    grid="true"
                    value={type}
                    refrance={typeRef}
                    onChange={(e) => setType(e.target.value)}
                  />
                  <div className="">
                    <GeniustextInput
                      title={"Status"}
                      value={status}
                      option={[
                        {
                          name: "Active",
                          value: "Active",
                        },
                        {
                          name: "Inactive",
                          value: "Inactive",
                        },
                      ]}
                      grid="true"
                      width="auto"
                      onChange={(e) => setStatus(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="h-fit max-w-[400px] ">
              <div className="mt-2 l:ml-4">
                <div className="border bg-white grid grid-cols-1 min-w-[280px] border-[#b5b3b3] rounded-sm p-4">
                  <div className="grid  grid-cols-1 l:grid-cols-2 gap-2 mt-3">
                    <GeniustextInput
                      title={"Prev. Balance"}
                      type={"text"}
                      value={prevBal}
                      refrance={prevBalRef}
                      grid={true}
                      onChange={(e) => setPrevBal(e.target.value)}
                    />
                    <GeniustextInput
                      title={"Balance Type"}
                      value={balType}
                      option={[
                        {
                          name: "Dr.",
                          value: "Dr.",
                        },
                        {
                          name: "Cr.",
                          value: "Cr.",
                        },
                      ]}
                      grid={true}
                      onChange={(e) => setBalType(e.target.value)}
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <GeniustextInput
                      title={"Discount %"}
                      type={"number"}
                      value={discount}
                      refrance={discountRef}
                      grid={true}
                      onChange={(e) => setDiscount(e.target.value)}
                    />

                    <GeniustextInput
                      title={"Rate Type"}
                      value={rateType}
                      option={[
                        {
                          name: "Sale Price",
                          value: "sale_price",
                        },
                        {
                          name: "Wholesale Price",
                          value: "whole_sale",
                        },
                      ]}
                      grid={true}
                      onChange={(e) => setRateType(e.target.value)}
                    />
                  </div>
<GeniustextInput
                    title={"Loyalty Point (Per 100 Rs.)"}
                    type={"text"}
                    value={loyalty}
                    refrance={loyaltyRef}
                    grid={true}
                    onChange={(e) => setLoyalty(e.target.value)}
                  />

<GeniustextInput
                    title={"Minimum point to redeem"}
                    type={"text"}
                    value={minLoyalty}
                    grid={true}
                    onChange={(e) => setMinLoyalty(e.target.value)}
                  />
                
                </div>
              </div>
            </div>

            <div className="h-fit   l:ml-4 max-w-[400px]">
              <div className="border border-[#b5b3b3] grid grid-cols-1 bg-white rounded-sm p-4 mt-2">
                <GeniustextInput
                  title={"Company Name"}
                  type={"text"}
                  grid={true}
                  value={companyData.COMPANY_NAME}
                  onChange={(t) => {
                    setCompanyData((old) => {
                      return {
                        ...old,
                        COMPANY_NAME: toProperCase(t.target.value),
                      };
                    });
                  }}
                />

                <GeniustextInput
                  title={"Company Mobile"}
                  type={"mobile"}
                  grid={true}
                  value={companyData.COMPANY_MOBILE}
                  onChange={(t) => {
                    setCompanyData((old) => {
                      return {
                        ...old,
                        COMPANY_MOBILE: t.target.value,
                      };
                    });
                  }}
                />

                <GeniustextInput
                  title={"GST Number"}
                  type={"text"}
                  grid={true}
                  value={companyData.TAX_NUMBER}
                  onChange={(t) => {
                    const panRegex = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;
                    const match = t.target.value.match(panRegex);
                    if (match) {
                      setCompanyData((old) => {
                        return {
                          ...old,
                          TAX_NUMBER: t.target.value,
                          PAN_NO: match[0],
                        };
                      });
                    } else {
                      setCompanyData((old) => {
                        return {
                          ...old,
                          TAX_NUMBER: t.target.value,
                        };
                      });
                    }
                  }}
                />

                <GeniustextInput
                  title={"PAN Number"}
                  grid={true}
                  type={"text"}
                  value={companyData.PAN_NO}
                  onChange={(t) => {
                    setCompanyData((old) => {
                      return {
                        ...old,
                        PAN_NO: t.target.value,
                      };
                    });
                  }}
                />

                <GeniustextInput
                  title={"TAN Number"}
                  type={"text"}
                  grid={true}
                  value={companyData.TAN}
                  onChange={(t) => {
                    setCompanyData((old) => {
                      return {
                        ...old,
                        TAN: t.target.value,
                      };
                    });
                  }}
                />

                <GeniustextInput
                  title={"Address"}
                  textArea={true}
                  grid={true}
                  value={companyData.COMPANY_ADDRESS}
                  onChange={(t) => {
                    setCompanyData((old) => {
                      return {
                        ...old,
                        COMPANY_ADDRESS: t.target.value,
                      };
                    });
                  }}
                />
              </div>

              <div className="mt-2 flex justify-end">
                <div>
                  {id ? (
                    <ModifyButton onClick={saveCustomerMaster} />
                  ) : (
                    <SaveButton onClick={saveCustomerMaster} />
                  )}
                </div>

                <div className="ml-1">
                  <UndoButton onClick={clearState} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CustomerMasterHelp
        status={customerMasterHelpStatus}
        onClose={() => {
          setCustomerMasterHelpStatus(false);
        }}
        onRowClick={(p) => {
          setId(p.row.CUSTOMER_CODE);
          setMobile(p.row.CUSTOMER_MOBILE);
          setCustomerName(p.row.CUSTOMER_NAME);
          setEmail(p.row.CUSTOMER_EMAIL);
          setAddress(p.row.CUSTOMER_ADDRESS);
          setType(p.row.CUSTOMER_TYPE);
setMinLoyalty(p.row.LOYALTY_POINT_AMT||0)
          setStatus(p.row.CUSTOMER_STATUS);
          setCity(p.row.CITY);
          handleCountryChange({
            target: {
              value: p.row.COUNTRY,
            },
          }).then((list) => {
            handleStateChange({
              target: {
                value: p.row.state,
                list: list,
              },
            });
          });
          setPinCode(p.row.PIN_CODE);
          setDiscount(p.row.DISQ_RATE);
          setLoyalty(p.row.LOYALTY_POINTS);
          setPrevBal(p.row.PRV_BAL);
          setEmailVerified(p.row.EMAIL_VERIFIED === "Yes");
          setMobileVerfied(p.row.MOBILE_VERIFIED === "Yes");
          setPrevBal(p.row.PRV_BAL);
          setCompanyData({
            COMPANY_NAME: p.row.COMPANY_NAME,
            COMPANY_ADDRESS: p.row.COMPANY_ADDRESS,
            COMPANY_MOBILE: p.row.COMPANY_MOBILE,
            TAX_NUMBER: p.row.TAX_NUMBER,
            PAN_NO: p.row.PAN_NO,
            TAN: p.row.TAN,
          });
          setBalType(p.row.BAL_TYPE);
          setRateType(p.row.RATE_TYPE);
          setCustomerMasterHelpStatus(false);
        }}
      />
      {!mobileStatus && (
        <OtpAlertModal
          status={otpStatus}
          otp={randome}
          onCancel={() => {
            setOtpStatus(false);
          }}
          onSubmit={() => {
            setOtpStatus(false);
            VerfiyMobileAPI().then((e) => console.log(e));
          }}
        />
      )}

      <EmailChangeModal
        status={emailStatus}
        email={email}
        list={customerList}
        VerfiyEmailSentAPI={VerfiyEmailSentAPI}
        onClose={() => {
          setEmailStatus(false);
        }}
      />

      <MobileChangeModal
        status={mobileStatus}
        mobile={mobile}
        randome={randome}
        sendOTP={OtpSentAPI}
        list={customerList}
        VerifyMobileSentAPI={VerfiyMobileAPI}
        onClose={() => {
          setMobileStatus(false);
        }}
        onRefresh={clearState}
      />
    </div>
  );
};

export default CustomerMaster;
